import ResponsiveDialog from '~/src/components/mui-wrappers/responsive-dialog'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import { Typography, useMediaQuery } from '@mui/material'
import { CustomMuiTheme, useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import { useTranslations } from '~/src/hooks/useTranslations'
import AuthenticationDialogTitle from '~/src/components/auth/dialogs/AuthenticationDialogTitle'
import { AUTHENTICATION_FLOW_STATE, AuthenticationFlowState } from '~/src/stores/authentication-flow'
import { useEoValue } from '~/src/hooks/useEoState'
import { useMemo } from 'react'
import ConfirmationCodeForm from '~/src/components/auth/confirmation-code/ConfirmationCodeForm'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'

const ConfirmationCodeDialog = () => {
  const theme = useCustomMuiTheme()
  const { t } = useTranslations()
  const { customer } = useEoValue<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)
  const authenticationFlowState = useEoValue<AuthenticationFlowState>(AUTHENTICATION_FLOW_STATE)
  const { restart } = useAuthenticationFlowDialogs()
  const isSmallDevice = useMediaQuery((theme: CustomMuiTheme) => theme.breakpoints.down('md'))

  const translationKeyPrefix = useMemo<string>(() => {
    if (authenticationFlowState.type === 'PASSWORD_RESET') {
      return 'auth.confirmationCode.dialog.passwordReset'
    }

    if (authenticationFlowState.type === 'ACTIVATION') {
      return 'auth.confirmationCode.dialog.activation'
    }

    return `auth.confirmationCode.dialog.${customer?.email ? 'email' : 'phone'}`
  }, [ customer?.email, customer?.phone, authenticationFlowState.loginTypeResponse?.type ])
  
  return (
    <ResponsiveDialog
      openByDefault={true}
      name={AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_CONFIRMATION_CODE}
      showPuller={isSmallDevice}
      showCloseButton
      Title={
        <AuthenticationDialogTitle
          showBackButton
          onBack={restart}>
          { t(`${translationKeyPrefix}.title`) }
        </AuthenticationDialogTitle>
      }
      titleSx={{
        px: `${theme.spacing(2)} !important`,
        gap: 1
      }}
      contentSx={{
        px: 3
      }}>
      <Typography
        variant='h6'
        sx={{
          fontSize: 'min(max(1rem, 4vw), 1.25rem)'
        }}>
        { t(`${translationKeyPrefix}.subTitle`) }
      </Typography>

      <Typography
        variant='subtitle2'
        sx={{
          textAlign: 'center',
          pt: 4,
          pb: 2
        }}>
        { t(`${translationKeyPrefix}.informationTitle`, {
          phone: customer!.phone!,
          email: customer!.email!
        }) }
      </Typography>

      <ConfirmationCodeForm fieldsColor='container'/>
    </ResponsiveDialog>
  )
}

export default ConfirmationCodeDialog
